/**
 * Progression de lecture (C11 SP3) — client de `GET /api/reading-progress` et
 * `PUT /api/reading-progress/{fileId}`. Enveloppe `{ success, data }` déballée ici.
 */
export type ReadingFileType = 'epub' | 'html' | 'docx' | 'pdf' | 'other';

export interface ReadingProgressDto {
    fileId: string;
    fileType: ReadingFileType;
    displayName: string;
    cfi?: string;
    chapterLabel?: string;
    /** 0-100 */
    percent: number;
    /** PDF (SP3 bis) : page courante, 1-based */
    page?: number;
    /** ISO 8601 */
    updatedDate: string;
}

export interface ReadingProgressInput {
    cfi?: string;
    chapterLabel?: string;
    /** PDF (SP3 bis) : page courante, 1-based */
    page?: number;
    percent: number;
}

// Azure SWA peut altérer le header Authorization : on envoie aussi 'accesstoken', non modifié.
const headers = (token: string) => ({ Authorization: `Bearer ${token}`, accesstoken: token, 'Content-Type': 'application/json' });

export async function listReadingProgress(token: string): Promise<ReadingProgressDto[]> {
    const res = await fetch('/api/reading-progress', { headers: headers(token) });
    if (!res.ok) throw new Error(`reading-progress ${res.status}`);
    const body = await res.json();
    return body.data ?? [];
}

export async function saveReadingProgress(token: string, fileId: string, input: ReadingProgressInput): Promise<ReadingProgressDto> {
    // `keepalive` : la dernière écriture part quand la page passe en arrière-plan
    // (`visibilitychange → hidden`), juste avant qu'Android ne suspende ou ne tue
    // l'application ; sans lui, la requête meurt avec la page et la position
    // quittée n'est jamais enregistrée. Le corps tient largement sous la limite
    // (64 Ko) de ce mode.
    const res = await fetch(`/api/reading-progress/${encodeURIComponent(fileId)}`, { method: 'PUT', headers: headers(token), body: JSON.stringify(input), keepalive: true });
    if (!res.ok) throw new Error(`reading-progress ${res.status}`);
    const body = await res.json();
    return body.data;
}
